module.exports = __webpack_public_path__ + "biao7.gif?a07ef36";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao7.gif
 ** module id = 62
 ** module chunks = 0
 **/